import React from 'react'
import { Link } from 'react-router-dom'
import Wish_1 from '../../assets/images/home_page_4/cart/01.png'

const WishList = () => {
  return (
    <>
      <section id="wishlist" className="wishlist-main-block cart-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive">
                <table className="table table-bordered cart-table">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className="text-center">Unit Price</th>
                      <th className="text-center">Quantity</th>
                      <th className="text-center">Subtotal</th>
                      <th className="text-center">Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="wishlist-product-block">
                          <div className="wishlist-product-img">
                            <Link to="#" title="">
                              <img
                                src={Wish_1}
                                className="img-fluid"
                                alt=""
                              />
                            </Link>
                          </div>
                          <div className="wishlist-product-dtl">
                            <Link to="#" title="">
                              <h4 className="wishlist-product-title">
                                Internal Operations Administrator
                              </h4>
                            </Link>
                          </div>
                        </div>
                      </td>
                      <td className="rate">
                        <Link to="#" title="">
                          $33.00
                        </Link>
                      </td>
                      <td>
                        <div className="qty-input">
                          <button
                            className="qty-count qty-count--minus"
                            data-action="minus"
                            type="button"
                          >
                            -
                          </button>
                          <input
                            className="product-qty"
                            type="number"
                            name="product-qty"
                            min={0}
                            max={10}
                            defaultValue={1}
                          />
                          <button
                            className="qty-count qty-count--add"
                            data-action="add"
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="rate">
                        <Link to="#" title="">
                          $33.00
                        </Link>
                      </td>
                      <td>
                        <div className="wishlist-delete-icon">
                          <i className="flaticon-close" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default WishList
